<script>
export default {
  data() {
    return {
      table: {
        headers: [
          {
            text: '',
            align: 'start',
            sortable: false,
            value: 'name',
            class:'text-center'
          },
          { text: this.$t('faq.standard'), value: '1', width: 64 },
          { text: this.$t('faq.compact'), value: '2', width: 64 },
        ],
        prices: [
          {
            name: this.$t('faq.national'),
            1: this.$t('faq.national.price.1'),
            2: this.$t('faq.national.price.2'),
          },
          {
            name: this.$t('faq.international'),
            1: this.$t('faq.international.price.1'),
            2: this.$t('faq.international.price.2'),
          },
          {
            name: this.$t('faq.merge'),
            1: this.$t('faq.merge.price.1'),
            2: this.$t('faq.merge.price.2'),
          },
          {
            name: this.$t('faq.franking'),
            1: this.$t('faq.franking.price.1'),
            2: this.$t('faq.franking.price.2'),
          },
          {
            name: this.$t('faq.paypal.fees'),
            1: this.$t('faq.paypal.fees.price.1'),
            2: this.$t('faq.paypal.fees.price.2'),
          }
        ]
      }
    }
  }
}
</script>
<template>
  <v-card outlined>
    <v-row justify="end" class="ma-3">
      <v-col cols="6"></v-col>
      <v-col
        cols="3"
        class="text-center azure">
        {{ $t('faq.price.table.left') }} <br />
        {{ $t('faq.price.table.left.sides') }}
      </v-col>
      <v-col
        cols="3"
        class="text-center azure">
        {{ $t('faq.price.table.right') }}<br />
        {{ $t('faq.price.table.right.sides') }}
      </v-col>
    </v-row>
    <v-row  class="ml-3">
      <v-col cols="6" class="azure">
        {{$t('faq.national')}}
      </v-col>
      <v-col
        cols="3"
        class="text-center" >
        {{$t('faq.national.price.1')}}
      </v-col>
      <v-col
        cols="3"
        class="text-center" >
        {{$t('faq.national.price.2')}}
      </v-col>
    </v-row>
    <v-row  class="ml-3">
      <v-col cols="6" class="azure">
        {{$t('faq.international')}}
      </v-col>
      <v-col
        cols="3"
        class="text-center" >
        {{$t('faq.international.price.1')}}
      </v-col>
      <v-col
        cols="3"
        class="text-center rounded">
        {{$t('faq.international.price.2')}}
      </v-col>
    </v-row>
    <v-row  class="ml-3">
      <v-col cols="6" class="azure">
       {{$t('faq.merge')}}
      </v-col>
      <v-col
        cols="6"
        class="text-center" >
        {{$t('faq.merge.price.2')}}
      </v-col>
    </v-row>
    <v-row  class="ml-3">
      <v-col cols="6" class="azure">
        {{$t('faq.franking')}}
      </v-col>
      <v-col
        cols="6"
        class="text-center" >
        {{$t('faq.franking.price.2')}}
      </v-col>
    </v-row>
    <v-row  class="ml-3">
      <v-col cols="6" class="azure">
        {{$t('faq.paypal.fees')}}
      </v-col>
      <v-col
        cols="6"
        class="text-center">
        0,35 EURO
      </v-col>
    </v-row>
  </v-card>
</template>
<style lang="scss" scoped>
  .azure {
    font-weight: bold;
  }
</style>
